const DEPLOY_ENV = process.env.DEPLOY_ENV || 'local';

const monolithPublicEndpoints = {
    local: 'https://www.udemy.dev',
    dev: 'https://www.udemy.dev',
    prod: 'https://www.udemy.com',
};

const graphQLPublicEndpoints = {
    local: 'https://www.udemy.dev/api/2024-01/graphql/',
    dev: 'https://www.udemy.dev/api/2024-01/graphql/',
    prod: 'https://www.udemy.com/api/2024-01/graphql/',
};

const graphQLInternalEndpoints = {
    local: 'https://api-platform.dev.udsrvs.net/api/2024-01/graphql/',
    dev: 'http://api-platform-graphql-2024-01.api-platform.svc.cluster.local/graphql/',
    prod: 'http://api-platform-graphql-2024-01.api-platform.svc.cluster.local/graphql/',
};

// Define custom API endpoint URL maps (keyed by environment: local, dev, prod) below
// <<Stencil::Block(customEndpointDefs)>>
// <</Stencil::Block>>

export const runtimeConfig = {
    internalConfig: {
        GRAPHQL_URL: process.env.INTERNAL_GRAPHQL_URL ?? graphQLInternalEndpoints[DEPLOY_ENV as keyof typeof graphQLInternalEndpoints],
        // Do not call the monolith from the server or CI
        MONOLITH_URL: process.env.INTERNAL_MONOLITH_URL ??
                                  monolithPublicEndpoints[DEPLOY_ENV as keyof typeof monolithPublicEndpoints],
        // Export custom server-side-only endpoint URLs (from env vars or endpoint maps) below
        // <<Stencil::Block(customInternalEndpointExports)>>
        // <</Stencil::Block>>
    },
    publicConfig: {
        GRAPHQL_URL: process.env.NEXT_PUBLIC_GRAPHQL_URL ?? graphQLPublicEndpoints[DEPLOY_ENV as keyof typeof graphQLPublicEndpoints],
        MONOLITH_URL: process.env.NEXT_PUBLIC_MONOLITH_URL ?? monolithPublicEndpoints[DEPLOY_ENV as keyof typeof monolithPublicEndpoints],
        // Export custom public endpoint URLs accessible from both server and client below
        // <<Stencil::Block(customPublicEndpointExports)>>
        // <</Stencil::Block>>
    },
};
